module.exports = __webpack_public_path__ + "img/stripe.15ed0f12.svg";